import {
  type PosthogExceptionEntry,
  exceptionValue,
} from "./posthog-exception-types";

const GTM_SCRIPT_FILE_PATTERN = /(^|\/)gtm\.js(\?|$)/;

const GTM_TAG_FAILURE_VALUE_PATTERN = /\bis not defined\b/;

function frameIsGoogleTagManager(frame: {
  filename?: string;
  abs_path?: string;
}): boolean {
  const file = frame.filename ?? frame.abs_path ?? "";
  return GTM_SCRIPT_FILE_PATTERN.test(file);
}

function frameIsFirstPartyAppCode(frame: {
  filename?: string;
  abs_path?: string;
}): boolean {
  const file = frame.filename ?? frame.abs_path ?? "";
  return file.includes("app:///") || file.includes("/_next/");
}

function exceptionIsGoogleTagManagerTagFailure(
  value: string,
  frames: Array<{ filename?: string; abs_path?: string }>,
): boolean {
  if (!GTM_TAG_FAILURE_VALUE_PATTERN.test(value)) return false;
  if (frames.length === 0) return false;
  if (!frames.some(frameIsGoogleTagManager)) return false;
  return !frames.some(frameIsFirstPartyAppCode);
}

export function isGoogleTagManagerInjectedTagNoise(
  entries: Array<PosthogExceptionEntry>,
): boolean {
  if (entries.length === 0) return false;
  return entries.every((entry) =>
    exceptionIsGoogleTagManagerTagFailure(
      exceptionValue(entry),
      entry.stacktrace?.frames ?? [],
    ),
  );
}
